export const required = {
  required: true,
  rules: [{ required: true, message: 'Campo obrigatório!' }],
};

export const block = {
  style: { width: '100%' },
};
